import React from 'react';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import './ExchangeSportsHomeView.scss';
import { RootState } from '../../models/RootState';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { IonRow } from '@ionic/react';
import ExchangeSportsIconList from '../../components/ExchSportsListNav/ExchangeSportsIconList';
import { SPORTS_ICONS } from '../../constants/SportsNavView';

type StoreProps = {
  loggedIn: boolean;
};

const UpComingEvents: React.FC<StoreProps> = (props) => {
  const { loggedIn } = props;
  const pathParams = useParams();
  const eventType = pathParams['eventType'];
  return (
    <>
      <div className="events-table-ctn">
        <div className="events-section">
          <div className="card">
            <div className="carw">
              <div className="arrow arrow-right">
                <div className="img-ctn">
                  <img
                    className={'sport-icon'}
                    alt={
                      SPORTS_ICONS[eventType]
                        ? SPORTS_ICONS[eventType]
                        : SPORTS_ICONS['Other']
                    }
                    src={
                      SPORTS_ICONS[eventType]
                        ? SPORTS_ICONS[eventType]
                        : SPORTS_ICONS['Other']
                    }
                  />
                </div>
                {eventType}
              </div>
            </div>
            <ExchangeSportsIconList />
            <IonRow className="comingsoon">Coming Soon</IonRow>
          </div>{' '}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
  };
};

export default connect(mapStateToProps)(UpComingEvents);
